import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';

var axios_instance = get_axios_instance(api_variables.SERVICE_SALARY_COMPONENT_TYPES);

const _pk_name = 'id';

const state = {
    data: [],
    isFetching: false,
    isSaving: false,
    isDeleting: false
};

const mutations = {
    set: (state, payload) => {
        state.data = payload;
    },

    addEntity: (state, payload) => {
        state.data.push(payload);
    },

    updateEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] === payload.id) {
                state.data.splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, payload) => {
        for (let i = 0; i < state.data.length; i++) {
            if (state.data[i][_pk_name] == payload) {
                state.data.splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    }
};

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit('setFetching', true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload.leId
                }
            });
            commit('setFetching', false);
            if (res.status == 200) {
                commit('set', res.data.rows);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.post('/', payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('addEntity', res.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async update({ commit }, payload) {
        try {
            commit('setSaving', true);
            let res = await axios_instance.put(`/${payload.id}`, payload);
            commit('setSaving', false);
            if (res.status == 200) {
                commit('updateEntityById', res.data);
            }
            return res;
        } catch (err) {
            throw errorHandler(err.response);
        }
    },

    async delete({ commit }, payload) {
        try {
            commit('setDeleting', true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit('setDeleting', false);
            if (res.status == 200) {
                commit('removeEntityById', payload.id);
            }
        } catch (err) {
            throw errorHandler(err.response);
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};